import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { primaryColor, secondaryColor } from "../../config/theme/colors";

type IconColor = "primary" | "secondary" | "white";

interface IconAiAgentProps {
  color?: IconColor;
}

const colorMap: Record<IconColor, string> = {
  primary: primaryColor,
  secondary: secondaryColor,
  white: "#ffffff",
};

export function IconAiAgent({ color = "primary" }: IconAiAgentProps) {
  const fillColor = colorMap[color];

  return (
    <SvgIcon>
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 20.55"
      >
        <g id="Graphs">
          <path
            fill={fillColor}
            d="M6.69,8h-.23c-.92,0-1.66.74-1.66,1.66s.74,1.66,1.66,1.66h.23c.91,0,1.66-.74,1.66-1.66s-.74-1.66-1.66-1.66ZM17.51,6.91h-.16c-1.51,0-2.74,1.23-2.74,2.74s1.23,2.74,2.74,2.74h.16c1.51,0,2.74-1.23,2.74-2.74s-1.23-2.74-2.74-2.74ZM17.51,11.6h-.16c-1.07,0-1.95-.87-1.95-1.95s.87-1.95,1.95-1.95h.16c1.07,0,1.95.87,1.95,1.95s-.87,1.95-1.95,1.95ZM22.65,7.36v-.87c0-1.11-.44-2.17-1.23-2.96-.79-.79-1.85-1.23-2.96-1.23h-3.66c-.26-1.33-1.41-2.3-2.8-2.3s-2.54.97-2.8,2.3h-3.66c-1.11,0-2.17.44-2.96,1.23s-1.23,1.85-1.23,2.96v.87H0v6.08h1.35v2.92c0,1.12.44,2.17,1.23,2.96.79.79,1.85,1.23,2.96,1.23h12.92c1.12,0,2.17-.44,2.96-1.23.79-.79,1.23-1.85,1.23-2.96v-2.92h1.35v-6.08h-1.35ZM12,.79c.94,0,1.74.63,1.98,1.51h-3.97c.24-.88,1.04-1.51,1.99-1.51ZM21.86,16.35c0,.9-.35,1.76-1,2.4-.64.64-1.5,1-2.4,1H5.54c-.9,0-1.76-.35-2.4-1s-1-1.5-1-2.4V6.49c0-.9.35-1.76,1-2.4.64-.64,1.5-1,2.4-1h12.92c.9,0,1.76.35,2.4,1,.64.64,1,1.5,1,2.4v9.86ZM9.39,9.65c0-1.51-1.23-2.74-2.74-2.74h-.16c-1.51,0-2.74,1.23-2.74,2.74s1.23,2.74,2.74,2.74h.16c1.51,0,2.74-1.23,2.74-2.74ZM6.65,11.6h-.16c-1.07,0-1.95-.87-1.95-1.95s.87-1.95,1.95-1.95h.16c1.07,0,1.95.87,1.95,1.95s-.87,1.95-1.95,1.95ZM17.55,8h-.23c-.91,0-1.66.74-1.66,1.66s.74,1.66,1.66,1.66h.23c.92,0,1.66-.74,1.66-1.66s-.74-1.66-1.66-1.66ZM15.37,14.79h-.05c-.56,0-1.02.42-1.09.96v-.82c0-.62-.5-1.12-1.12-1.12s-1.12.5-1.12,1.12v.48c-.07-.55-.54-.97-1.11-.97-.62,0-1.12.5-1.12,1.12v.19c-.07-.54-.53-.95-1.09-.95h-.05c-.61,0-1.1.49-1.1,1.1s.49,1.1,1.1,1.1h.05c.56,0,1.02-.42,1.09-.95v.19c0,.62.5,1.12,1.12,1.12.57,0,1.04-.43,1.11-.98v.48c0,.62.5,1.12,1.12,1.12s1.12-.5,1.12-1.12v-.82c.07.54.53.95,1.09.95h.05c.61,0,1.1-.49,1.1-1.1s-.49-1.1-1.1-1.1h0Z"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}
